import { render, staticRenderFns } from "./InboxIconHover.vue?vue&type=template&id=1ead1722"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ead1722')) {
      api.createRecord('1ead1722', component.options)
    } else {
      api.reload('1ead1722', component.options)
    }
    module.hot.accept("./InboxIconHover.vue?vue&type=template&id=1ead1722", function () {
      api.rerender('1ead1722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/InboxIconHover.vue"
export default component.exports